<template>
  <div>
    <!-- 设施增加情况 -->
    <Echart :options="options" height="380px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    LAdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    LAdata: {
      handler(newData) {
        let color = ["#b31f26", "#aa8d30", "#d169b5", "#3cb162"];
        // let legendItem = ['感统', '心理', '认知', '情绪'];
        // let xAxisData = newData.data.map((v) => v.name);
        // // ["1", "2", "3", "4", "5", "6", "7", "8"]
        // let yAxisData1 = newData.data.map((v) => v.value1);
        // // [100, 138, 350, 173, 180, 150, 180, 230]
        // let yAxisData2 = newData.data.map((v) => v.value2);
        // // [233, 233, 200, 180, 199, 233, 210, 180]
        // let yAxisData3 = newData.data.map((v) => v.value3);
        // let yAxisData4 = newData.data.map((v) => v.value4);
        const hexToRgba = (hex, opacity) => {
          let rgbaColor = "";
          let reg = /^#[\da-f]{6}$/i;
          if (reg.test(hex)) {
            rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
              "0x" + hex.slice(3, 5)
            )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
          }
          return rgbaColor;
        };
        let seriesArr = [];
        newData.yAxisDataArr.map(item => {
          let seriesItem = {
            name: item.seriesName,
            type: "line",
            smooth: true, //是否平滑
            // showSymbol: true,
            itemStyle: {
              // color: "rgb(255,255,255)"
            },
            symbolSize: 8,
            zlevel: 3,
            lineStyle: {
              normal: {
                // color: color[0],
                shadowBlur: 3,
                shadowColor: hexToRgba(color[0], 0.5),
                shadowOffsetY: 0
              }
            },
            data: item.seriesData
          };
          seriesArr.push(seriesItem);
        });

        this.options = {
          color: color,
          grid: {
            top: "35%",
            left: "10%",
            right: "10%",
            bottom: "10%",
            containLabel: true
          },
          legend: {
            // center: true,
            top: "28%",
            right: 50,
            data: newData.legends
          },
          tooltip: {
            trigger: "axis",
            formatter: function(params) {
              let html = "";
              params.forEach(v => {
                html += `<div style="color: #666;font-size: 14px;line-height: 24px">
                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                  color[v.componentIndex]
                };"></span>
                ${v.seriesName}
                <span style="color:${
                  color[v.componentIndex]
                };font-weight:700;font-size: 18px">${v.value}</span>
                个`;
              });

              return html;
            },
            extraCssText:
              "background: #fff; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;"
          },
          xAxis: {
            type: "category",
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "rgba(255, 255, 255,0.5)"
              }
            },
            boundaryGap: false, // 是否贴边
            splitLine: {
              show: true,
              lineStyle: {
                color: "#1e3665",
                width: 2
              }
            },
            axisLabel: {
              inside: false,
              textStyle: {
                color: "rgba(255, 255, 255,0.7)", // x轴颜色
                fontWeight: "normal",
                fontSize: "14",
                lineHeight: 22
              }
            },

            data: newData.xAxisData
          },
          yAxis: {
            type: "value",
            name: "单位/个",
            axisLabel: {
              show: true,
              alignWithLabel: true,
              interval: 0,
              inside: false,
              length: 20
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#1e3665",
                width: 2
              }
            },
            nameTextStyle: {
              color: "rgba(255, 255, 255,0.7)",
              fontSize: 12,
              lineHeight: 40,
              padding: [0, 0, 0, -20]
            },
            axisLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "rgba(255, 255, 255,0.5)"
              }
            },
            axisTick: {
              show: false
            }
          },
          series: seriesArr
        };
      },
      // immediate: true,
      deep: true
    }
  }
};
</script>
